import { useIntl } from 'react-intl';

import { globalMessages } from '@/core/messages/global.messages';

export const useLocalizedOGTitle = (title: string) => {
  const { formatMessage } = useIntl();

  return `${title} | ${formatMessage(globalMessages.defaultSeoTitle)}`;
};
